export default __webpack_public_path__ + "static/media/topic1200.2e2e9ab7.png";